module.exports = __webpack_public_path__ + "img/prize-01.0c268ea8.png";